module.exports = __webpack_public_path__ + "static/img/guide-topico5.a6269e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide-topico5.png
// module id = U3I8
// module chunks = 1